// extracted by mini-css-extract-plugin
export default {"image":"StaticPage_image__9rqYJ"};